const createImage = (url) =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.setAttribute("crossOrigin", "anonymous");

		image.onload = () => resolve(image);
		image.onerror = (error) => reject(error);

		image.src = url;
	});

export default async function getCroppedImg(
	imageSrc,
	crop,
	fileName = "cropped.jpg",
) {
	const image = await createImage(imageSrc);

	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");

	canvas.width = crop.width;
	canvas.height = crop.height;

	ctx.drawImage(
		image,
		crop.x,
		crop.y,
		crop.width,
		crop.height,
		0,
		0,
		crop.width,
		crop.height,
	);

	return new Promise((resolve) => {
		canvas.toBlob(
			(blob) => {
				if (!blob) return;

				const file = new File([blob], fileName, {
					type: "image/jpeg",
					lastModified: Date.now(),
				});

				resolve(file);
			},
			"image/jpeg",
			0.95,
		);
	});
}
